import React, { Component } from 'react'
import { connect } from 'react-redux'
import autoBind from 'auto-bind'
//import ReactGA from 'react-ga'

/** Import language sections */
import { renderToStaticMarkup } from 'react-dom/server'
import { withLocalize } from 'react-localize-redux'
import translations from './resources/translations.json'
import UserManager from './store/helpers/UserManager'

/** Import components */
import AnonymousView from './views/AnonymousView'
import MainContainer from './views/MainContainer'

/** Resources import themes portal */
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles'
import themePtm from './resources/themes/themePTM.json'
import themeMPV from './resources/themes/themeMPV.json'

import { COMPANY_THEME_ACTIVE, COMPANY_PTM, COMPANY_MPV } from './store/helpers/ResourcesHelper'
import { IsNullOrEmpty } from './store/helpers/StringHelper.js'
import { ENVIROMENT_TYPE_PRODUCTION } from './store/helpers/ResourcesHelper'

/**
 * App component
 *
 * @class App
 * @extends {Component}
 */
class App extends Component {
	/**
	 *Creates an instance of App.
	 * @param {*} props
	 * @memberof App
	 */
	constructor(props) {
		super(props)
		autoBind(this)
		this.state = {
			themeActive: createMuiTheme(themePtm),
			user: null,
		}

		let defaultLanguage = localStorage.getItem('language')
		if (!defaultLanguage) {
			defaultLanguage = 'es'
		}

		this.props.initialize({
			languages: [
				{ name: 'EspaÃ±ol', code: 'es' },
				{ name: 'English', code: 'en' },
				{ name: 'Portugues', code: 'pt' },
			],
			translation: translations,
			options: {
				renderToStaticMarkup,
				defaultLanguage: defaultLanguage,
			},
		})
	}

	// initializeReactGA(pageAddress) {
	// 	ReactGA.initialize('UA-147073792-1')
	// 	ReactGA.pageview(pageAddress)
	// }

	/**
	 * componentDidMount
	 */
	componentDidMount() {
		/** Redirect to url stored in local storage if it exist when is open from link */
		if (process.env.PUBLIC_URL === ENVIROMENT_TYPE_PRODUCTION) {
			let urlToRedirect = localStorage.getItem('relativeUrl')
			if (!IsNullOrEmpty(urlToRedirect)) {
				this.props.history.push(urlToRedirect)
			}
		}

		/// get theme active or change theme active
		let themeActive = localStorage.getItem(COMPANY_THEME_ACTIVE)
		if (themeActive) {
			this.changeTheme(themeActive)
		}
		/// verify if exit uder
		UserManager.getUser().then((user) => {
			this.setState({ user })
		})
		/// redirect to IS4 login when access token expires
		UserManager.events.addAccessTokenExpired(this.onSessionExpired)
	}

	/**
	 * componentWillUnmount
	 */
	componentWillUnmount() {
		UserManager.events.removeAccessTokenExpired(this.onSessionExpired)
	}

	/**
	 * Called when IS4 invalidates the session (token expired or remote sign-out).
	 * Redirects immediately to IS4 login instead of leaving a blank user state.
	 */
	onSessionExpired() {
		UserManager.signinRedirect().catch((err) => {
			console.error('signinRedirect failed after session expired', err)
		})
	}

	/**
	 * Function to change theme company
	 * @param {*} company
	 */
	changeTheme(company) {
		switch (company) {
			case COMPANY_PTM:
				this.setState({ themeActive: createMuiTheme(themePtm) })
				break
			case COMPANY_MPV:
				this.setState({ themeActive: createMuiTheme(themeMPV) })
				break
			default:
				this.setState({ themeActive: createMuiTheme(themePtm) })
				break
		}
	}

	/**
	 * Render
	 *
	 * @returns
	 * @memberof App
	 */
	render() {
		const search = this.props.location.search
		if (!IsNullOrEmpty(search)) {
			localStorage.setItem('url', search)
		}
		//this.initializeReactGA(this.props.location.pathname)
		let container = ''
		if (!this.state.user) {
			container = <AnonymousView {...this.props} />
		} else {
			container = <MainContainer {...this.props} />
		}
		return <MuiThemeProvider theme={this.state.themeActive}>{container}</MuiThemeProvider>
	}
}

/**
 *
 * Defines the properties injecteded from the state to App props
 *
 * @param {object} state
 * @returns
 */
function mapStateToProps(store) {
	return {
		oidc: store.oidc,
	}
}

export default withLocalize(connect(mapStateToProps, null)(App))
